module.exports = __webpack_public_path__ + "static/media/01n.bdd290f5.svg";